import  { useState,useEffect } from 'react';

const ThemeSettings = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [logoHeaderColor, setLogoHeaderColor] = useState("dark");
  const [navbarColor, setNavbarColor] = useState("white");
  const [sidebarColor, setSidebarColor] = useState("dark");

  const toggleSettings = () => {
    setIsOpen(!isOpen);
  };

  const handleColorChange = (section, color) => {
    if (section === "logo") {
      setLogoHeaderColor(color);
    } else if (section === "navbar") {
      setNavbarColor(color);
    } else if (section === "sidebar") {
      setSidebarColor(color);
    }
  };

  useEffect(() => {
  const sidebar = document.querySelector(".sidebar");
  const logoHeader = document.querySelector(".logo-header");
  const navbar = document.querySelector(".navbar-header");

  if (sidebar) {
    sidebar.setAttribute("data-background-color", sidebarColor);
  }

  if (logoHeader) {
    logoHeader.setAttribute("data-background-color", logoHeaderColor);
  }

  if (navbar) {
    navbar.setAttribute("data-background-color", navbarColor);
  }
}, [logoHeaderColor, navbarColor, sidebarColor]);

  return (
    <>
     {/* Custom template | don't include it in your project! */}
  <div className={`custom-template ${isOpen ? "open" : ""}`}>
    <div className="title">Settings</div>
    <div className="custom-content">
      <div className="switcher">
        <div className="switch-block">
          <h4>Logo Header</h4>
           <div className="btnSwitch">
                {[
                  "dark", "blue", "purple", "light-blue", "green",
                  "orange", "red", "white", "dark2", "blue2",
                  "purple2", "light-blue2", "green2", "orange2", "red2"
                ].map((color) => (
                  <button
                    key={color}
                    type="button"
                    className={`changeLogoHeaderColor ${logoHeaderColor === color ? "selected" : ""}`}
                    data-color={color}
                    onClick={() => handleColorChange("logo", color)}
                  />
                ))}
              </div>
        </div>
        <div className="switch-block">
          <h4>Navbar Header</h4>
           <div className="btnSwitch">
                {[
                  "dark", "blue", "purple", "light-blue", "green",
                  "orange", "red", "white", "dark2", "blue2",
                  "purple2", "light-blue2", "green2", "orange2", "red2"
                ].map((color) => (
                  <button
                    key={color}
                    type="button"
                    className={`changeTopBarColor ${navbarColor === color ? "selected" : ""}`}
                    data-color={color}
                    onClick={() => handleColorChange("navbar", color)}
                  />
                ))}
              </div>
        </div>
        <div className="switch-block">
          <h4>Sidebar</h4>
           <div className="btnSwitch">
                {["white", "dark", "dark2"].map((color) => (
                  <button
                    key={color}
                    type="button"
                    className={`changeSideBarColor ${sidebarColor === color ? "selected" : ""}`}
                    data-color={color}
                    onClick={() => handleColorChange("sidebar", color)}
                  />
                ))}
              </div>
        </div>
      </div>
    </div>
    <div className="custom-toggle" onClick={toggleSettings}>
      <i className="icon-settings" />
    </div>
  </div>
  {/* End Custom template */}

   
    </>
  )
}

export default ThemeSettings;
